module.exports = __webpack_public_path__ + "static/media/tap_button1_img.5522487f.png";